<template>
    <div id="topbar-container">
        <div id="summary" v-if="summary">
            <div v-if="summary.total != null" class="row">
                {{ $t('production.summary.forecast') }}: <span class="value">{{ formatCurrency(summary.total) }}</span>
            </div>
            <div v-if="summary.agg_actual != null" class="row">
                {{ $t('production.summary.current') }}: <span class="value">{{ formatCurrency(summary.agg_actual) }}</span>
            </div>
            <div v-if="summary.agg_difference_percentage != null" class="row current">
                {{ $t('sales.table.header.difference') }}: <span class="value" :class="{ positive: summary.agg_difference_percentage > 0, negative: summary.agg_difference_percentage < 0, neutral: summary.agg_difference_percentage == 0 }">{{ formatDisplayPercent(summary.agg_difference_percentage, 1, true) }}</span>
            </div>
            <!-- <div v-if="summary.last_update" class="row">
                {{ $t('production.summary.last_update') }}: <span class="value update">{{ summary.last_update }}</span>
            </div> -->
        </div>
    </div>
</template>

<script>
import { formatPercent } from '@/utils/numberFormat'
import { formatNumberLabel } from '@/utils/numberFormat'
import { formatDate as formatReferenceDate } from '@/utils/dateUtils'
import { formatCurrency } from "@/utils/formatters";

export default {
    name: 'Sidebar',
    props: { summary: { type: Object } },
    data() {
        return {}
    },
    computed: {},
    methods: {
        formatDisplayPercent(value, level = 1, allowNegative = false) { return formatPercent(value, this.$i18n.locale, level, { allowNegative }) },
        formatDisplayNumber(value, fractionDigits) {
            return formatNumberLabel(value, this.$i18n.locale, fractionDigits)
        },
        formatDate(date) {
            return formatReferenceDate(date)
        },
        isValidDate(dateString) {
            return moment(dateString, 'YYYY-MM-DD', true).isValid()
        },
        formatCurrency(amount) {
            return formatCurrency(amount)
        }
    },
    created() {},
    watch: {}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
#summary {
    width: 100%;
    bottom: 0;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    background-color: #fff;
    padding: 15px 15px;
    justify-items: start;
    grid-template-columns: repeat(3, 1fr);
    display: grid;
    margin-bottom: 16px;
    border-radius: 4px;

    .row {
        display: flex;
        flex-direction: column;
        align-content: center;
        align-items: center;
        justify-content: space-between;
        gap: 15px;
        flex-wrap: nowrap;
        word-break: break-word;
        width: 100%;
        padding: 4px 0;
        @include font-size(m);
        line-height: 100%;

        .value {
            font-family: $text-bold;
            text-align: right;
            @include font-size(xl);

            &.update {
                font-family: $text;
            }
        }

        &.current {
            margin-top: 0px;
            .value {
                padding: 4px 8px;
                border-radius: 3px;
                color: #fff;
                width: auto;
                min-width: 90px;
                text-align: center;
                &.positive {
                    background-color: $color-success-500;
                }
                &.negative {
                    background-color: $color-error-500;
                }
                &.neutral {
                    background-color: $color-neutral-500;
                }
            }
        }
    }
}

@media (orientation: portrait) {
    #summary {
        .row {
            .value {
                @include font-size(l);
                padding: 8px;
            }
            &.current {
                .value {
                    padding: 8px 16px;
                }
            }
        }
    }
}
</style>
